import {SectionModel} from "./section.model";
import {ModelComponentsMap} from "@white-label/components/page-builder/models/model.map";
import {NavigationModel} from "@white-label/components/page-builder/models/navigation.model";
import {devIp} from "browser-sync/dist/utils";


export class PageBuilderModel {
    backgroundImage: string | null = '/assets/image/image_placeholder.svg';
    metaShareImage: string | null = '/assets/image/image_placeholder.svg';
    slug: string | null = '/';
    title: string = 'Demo title';
    metaTitle: string | null = 'Demo meta title';
    keywords: string | null = 'Demo keywords';
    metaDescription: string | null = 'Demo meta description';
    layout: 'one' | 'full' | 'ltr' | 'rtl' | null = 'one';
    sections: SectionModel[] = [];
    sectionsLtr: SectionModel[] = [];
    sectionsRtl: SectionModel[] = [];
    headerNavigation: NavigationModel = new NavigationModel();
    footerNavigation: NavigationModel = new NavigationModel();



    backgroundColor: string | null = '#000';


    id: string | null = null;

    constructor(data?: {backgroundImage?: any,
                metaShareImage?: any,
                backgroundColor?: any,
                slug?: any,
                title?: any,
                headerNavigation?: any,
                footerNavigation?: any,
                metaTitle?: any,
                keywords?: any,
                metaDescription?: any,
                sections?: any,
                sectionsLtr?: any,
                layout?: any,
                sectionsRtl?: any,
                id?: any}) {
        if(data?.backgroundImage){
            this.backgroundImage = data.backgroundImage;
        }
        if(data?.metaShareImage){
            this.metaShareImage = data.metaShareImage;
        }
        if(data?.backgroundColor){
            this.backgroundColor = data.backgroundColor;
        }
        if(data?.slug){
            this.slug = data.slug;
        }
        if(data?.title){
            this.title = data.title;
        }
        if(data?.layout){
            this.layout = data.layout;
        }
        if(data?.metaTitle){
            this.metaTitle = data.metaTitle;
        }
        if(data?.keywords){
            this.keywords = data.keywords;
        }
        if(data?.metaDescription){
            this.metaDescription = data.metaDescription;
        }
        if(data?.sections){
            for(let key in data?.sections){
                const currentSection = data?.sections[key];
                let componentSection = new SectionModel(data?.sections[key]);
                if(ModelComponentsMap[currentSection.component]){
                    componentSection.data = new ModelComponentsMap[currentSection.component](componentSection.data);
                }
                this.sections.push(componentSection);
            }
        }
        if(data?.sectionsLtr){
            for(let key in data?.sectionsLtr){
                const currentSection = data?.sectionsLtr[key];
                let componentSection = new SectionModel(data?.sectionsLtr[key]);
                if(ModelComponentsMap[currentSection.component]){
                    componentSection.data = new ModelComponentsMap[currentSection.component](componentSection.data);
                }
                this.sectionsLtr.push(componentSection);
            }
        }
        if(data?.sectionsRtl){
            for(let key in data?.sectionsRtl){
                const currentSection = data?.sectionsRtl[key];
                let componentSection = new SectionModel(data?.sectionsRtl[key]);
                if(ModelComponentsMap[currentSection.component]){
                    componentSection.data = new ModelComponentsMap[currentSection.component](componentSection.data);
                }
                this.sectionsRtl.push(componentSection);
            }
        }
        if(data?.headerNavigation){
            this.headerNavigation = new NavigationModel(data.headerNavigation) ;
        }
        if(data?.footerNavigation){
            this.footerNavigation = new NavigationModel(data.footerNavigation);
        }
        if(data?.id){
            this.id = data.id;
        }
    }

}